// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"4518a845","329":"95324584","349":"1b938a04","939":"f5eb90dd"}[chunkId] + ".chunk.js";
};